var _path, _path2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadiusIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "4 4 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16,7.29c4.42,0,8.07,3.31,8.63,7.58h1.01c-.56-4.82-4.67-8.58-9.64-8.58S6.93,10.05,6.36,14.87h1.01c.56-4.27,4.21-7.58,8.63-7.58Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,24.71c-4.42,0-8.07-3.31-8.63-7.58h-1.01c.56,4.82,4.67,8.58,9.64,8.58s9.08-3.76,9.64-8.58h-1.01c-.56,4.27-4.21,7.58-8.63,7.58Z"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "24.39 16 20.33 14.34 21.15 15.75 10.65 15.75 11.47 14.34 7.41 16 11.47 17.66 10.65 16.25 21.15 16.25 20.33 17.66 24.39 16"
})));
export default SvgRadiusIcon;